import { render, staticRenderFns } from "./parkingLotConfigContent.vue?vue&type=template&id=2ef3572a&scoped=true"
import script from "./parkingLotConfigContent.vue?vue&type=script&lang=js"
export * from "./parkingLotConfigContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef3572a",
  null
  
)

export default component.exports